import { render, staticRenderFns } from "./AStepItem.vue?vue&type=template&id=1bcce941&"
import script from "./AStepItem.vue?vue&type=script&lang=js&"
export * from "./AStepItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports